export const orderLookupFieldDropdown =  [
	{
	  title: "FedEx Order ID",
	  value: "fedExOrderId"
	},
	{
	  title: "Channel Order ID",
	  value: "channelOrderId"
	},
	{
	  title: "Channel",
	  value: "channel"
	},
	{
	  title: "Customer Name",
	  value: "customerName"
	},
	{
	  title: "Tracking Number",
	  value: "trackingNumber"
	},
	{
	  title: "State",
	  value: "state"
	},
	{
	  title: "City",
	  value: "city"
	},
	{
	  title: "Country",
	  value: "country"
	},
	{
	  title: "Product Name (SKU)",
	  value: "productName"
	},
	{
	  title: "RMA Number",
	  value: "rmaId"
	},
	{
	  title: "Shipping Method",
	  value: "shippingMethod"
	}
]



// WEBPACK FOOTER //
// ./src/pages/order/filter/orderLookupFieldDropdown.js